import React from 'react'
import { AddPictureIcon, AlertIcon, CommentIcon, LikeIcon, OilIcon, PersonIcon, PictureIcon, QRIcon, ShareIcon, ShopIcon } from "../../../assets/icons"

const showIcon = (type) => {
    let icon;
    switch (type) {
        case "PDA":
            return <AlertIcon />
        case "NSA":
            return <PersonIcon />
        case "NR":
            return <LikeIcon />
        case "NSP":
            return <ShareIcon />
        case "NC":
            return <CommentIcon />
        case "NMP":
            return <QRIcon />
        case "NOD":
            return <OilIcon />
        case "NLLS":
            return <AlertIcon />
        case "NNP":
            return <PictureIcon />

        default:
            return <LikeIcon />
    }
}
export default showIcon;